import { TWO_MONTHS_IN_PAST } from "./dateHelper";
import { set_time_to_midnight } from "./dateTimeFormatter";
import { setEndDateTime, setStartDateTime } from "./inputValidation";
import {
  END_DATE_IS_REQUIRED,
  INVALID_EMPLOYEE_ID,
  INVALID_END_DATE,
  INVALID_START_DATE,
  SHIFT_TIME_IS_REQUIRED,
  START_DATE_IS_REQUIRED,
} from "./messageConstants";
import {
  TOR_SUBMISSION_CUTOFF_TIME_REMINDER,
  isEADorEDUorSEAD,
  setTimeToMidnightForEADorEDUorSEAD,
} from "./timeOffRequestUtils";

export function TOR_validateShiftStartDate(input, station, timeOffType, empUnionContract) {
  let errorMessage = "";
  let maxDate =
    empUnionContract &&
    timeOffType &&
    TOR_SUBMISSION_CUTOFF_TIME_REMINDER[empUnionContract][timeOffType]
      .getMaxSubmissionShiftDate(station)
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

  if (input === null) {
    return (errorMessage = START_DATE_IS_REQUIRED);
  }

  const startDateVal = set_time_to_midnight(input);

  if (startDateVal.toMillis() < TWO_MONTHS_IN_PAST(station).toMillis()) {
    errorMessage = "Start Date cannot be more than 2 months in the past";
  }

  if (maxDate < startDateVal) {
    return INVALID_START_DATE;
  }

  return errorMessage;
}

export function TOR_validateShiftEndDate(startDate, input, station, timeOffType, empUnionContract) {
  let maxDate =
    empUnionContract &&
    timeOffType &&
    TOR_SUBMISSION_CUTOFF_TIME_REMINDER[empUnionContract][timeOffType]
      .getMaxSubmissionShiftDate(station)
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      // Plus 1 day for end date validation to cover shifts crossing midnight
      .plus({ day: 1 });

  if (input === null) {
    return END_DATE_IS_REQUIRED;
  }
  if (startDate === null) {
    return "";
  }

  const startDateVal = set_time_to_midnight(startDate);
  const endDateVal = set_time_to_midnight(input);

  if (endDateVal.toMillis() < startDateVal.toMillis()) {
    return INVALID_END_DATE;
  }

  if (maxDate < endDateVal) {
    return INVALID_END_DATE;
  }

  return "";
}

export function TOR_validateShiftStartTime(timeOffType, startDate, startHour, startMin, endHour, endMin) {
  // It's expected that both hourInput and minInput have been touched when
  // this validation is called.
  if (startHour.toString().trim() === "" || startMin.toString().trim() === "") {
    if (isEADorEDUorSEAD(timeOffType) && endHour.toString().trim() === "" && endMin.toString().trim() === "") {
      return "";
    } else {
      return SHIFT_TIME_IS_REQUIRED;
    }
  }
  if (startDate === null) {
    // This is to protect against NPE if user touches
    // start times but doesn't select a valid input
    // (start time input validation will catch this for the user)
    return "";
  }
  return "";
}

export function TOR_validateShiftEndTime(
  timeOffType,
  startDate,
  endDate,
  startHourInput,
  startMinInput,
  endHourInput,
  endMinInput,
  station
) {
  // It's expected that both hourInputs and both minInputs have been touched when
  // this validation is called.
  if (endHourInput.toString().trim() === "" || endMinInput.toString().trim() === "") {
    if (
      isEADorEDUorSEAD(timeOffType) &&
      startHourInput.toString().trim() === "" &&
      startMinInput.toString().trim() === ""
    ) {
      return "";
    } else {
      return SHIFT_TIME_IS_REQUIRED;
    }
  }
  if (
    startHourInput.toString().trim() === "" ||
    startMinInput.toString().trim() === "" ||
    startDate === null ||
    endDate === null
  ) {
    // This is to protect against NPE if user touches
    // start times but doesn't select a valid input
    // (start time input validation will catch this for the user)
    return "";
  }

  var startDateVal = setStartDateTime(startDate, startHourInput, startMinInput, station);
  var endDateVal = setEndDateTime(endDate, endHourInput, endMinInput, station);
  var midnightForGivenDate = setTimeToMidnightForEADorEDUorSEAD(endDate, station);

  if (endDateVal.toMillis() <= startDateVal.toMillis()) {
    if (isEADorEDUorSEAD(timeOffType) && endDateVal.equals(startDateVal) && endDateVal.equals(midnightForGivenDate)) {
      return "";
    } else {
      return "Invalid End Time";
    }
  }

  return "";
}

export function validateOwnTimeOffRequestEmployeeId(input, userId) {
  if (userId === input) {
    return "You cannot create time off for yourself";
  }
  return "";
}

export function validateEmployeeDataForAdminCreateTimeOffRequest(input, selectedStation) {
  if (input === null) {
    return "Not loaded";
  }

  if (!input.isActive) {
    return INVALID_EMPLOYEE_ID;
  }
  if (input.activeStation !== selectedStation && input.homeStation !== selectedStation) {
    return "Employee must work in " + selectedStation;
  }

  return "";
}

export function TOR_validateShiftTwoMonthDeadline(shiftDate, shiftHour, shiftMinute, station) {
  if (shiftDate === null) {
    // This is to protect against NPE if user touches
    // start times but doesn't select a valid input
    // (start time input validation will catch this for the user)
    return "";
  }
  const shiftStartDate = shiftDate.set({ hour: shiftHour, minute: shiftMinute, second: 0, millisecond: 0 });

  if (shiftStartDate < TWO_MONTHS_IN_PAST(station)) {
    return "Shift time past 2 months deadline";
  }
  return "";
}
